exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grey-icon[data-v-233806a3] {\n  color: #5c5c5c;\n}\n.green[data-v-233806a3] {\n  color: green;\n}\n.red[data-v-233806a3] {\n  color: red;\n}\n.place-center[data-v-233806a3] {\n  text-align: center;\n  width: 100%;\n}\n.custom-control[data-v-233806a3] {\n  margin-right: -0.5rem;\n}\n", ""]);

// exports
